import React, { forwardRef } from 'react';

import Section from '../../containers/Section';
import * as SimpleIcon from 'react-icons/si';

import { useInView } from 'react-intersection-observer';

const contentData = [
  { name: 'Email', elementName: 'SiGmail', link: 'https://mail.google.com/mail/u/0/?fs=1&to=jokovivanco@gmail.com' },
  { name: 'Whatsapp', elementName: 'SiWhatsapp', link: 'https://api.whatsapp.com/send?phone=6282254500939' },
  { name: 'Instagram', elementName: 'SiInstagram', link: 'https://www.instagram.com/ui.cotechca/' },
  { name: 'Fiverr', elementName: 'SiFiverr', link: '#' }
]

const Contact = forwardRef((_, ref) => {
  const { ref: scrollRef, inView } = useInView({
    threshold: 0.4,
    triggerOnce: true
  })

  return (
    <Section innerClass="pb-10 max-w-[90%] xl:max-w-[80%] lg:pt-16 2xl:my-24" outerClass="bg-white" ref={scrollRef}>
      <div className="uppercase text-xl text-center pt-16 tracking-widest text-slate-700 lg:text-2xl 2xl:text-3xl" ref={ref}>Contact Us</div>
      <ul className={`flex pt-16 flex-wrap md:space-x-8 md:justify-center transition-transform duration-1000 ${inView ? 'md:translate-y-0' : 'md:translate-y-20 2xl:translate-y-40'} 2xl:mt-20`}>
        {contentData.map(content => {
          const element = React.createElement(SimpleIcon[content.elementName], { className: "w-16 h-16" });
          return (
            <li key={content.name} className="basis-1/2 flex justify-center md:basis-auto md:shadow-md md:w-32 md:h-32 md:shadow-green-500/20">
              <a href={content.link} target="_blank">
                <button className="flex items-center flex-col px-2 mb-10 space-y-4 md:mb-0 md:px-0 md:p-4">
                  {element}
                  <div className="uppercase text-center text-base tracking-widest text-slate-600 mt-2">{content.name}</div>
                </button>
              </a>
            </li>
          );
        })}
      </ul>
    </Section>
  );
});

export default Contact;
